<template>
  <div class="analysisVerification">
    <analysis-sidebar></analysis-sidebar>
    <a class="float-sm-left" href="https://github.com/CHIMEFRB/frb-web/blob/master/src/components/Analysis/analysis_verification.vue" target="_blank" style="color:black">
      <b-icon icon="github" aria-hidden="true" font-scale="1.0"></b-icon>
    </a>
    <h4>Event Verification</h4>
    <events></events>
  </div>
</template>
<script>
import Events from '../events'
import analysisSidebar from './analysisSidebar'
export default {
  data () {
    return {}
  },
  components: {
    'events': Events,
    'analysis-sidebar': analysisSidebar
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Analysis/analysis_verification.vue